<template>
<div>
  <div class="LayoutDefault container p-shadow-1">
    <div v-if="userHasPremission">
      <div class="p-mb-6">
        <navmenu />
        <Message v-if="project && !project.active" severity="warn" class="p-mt-0" :closable="false">Prosjektet er avsluttet</Message>
      </div>
      <main :key="forceRerender">
        <slot/>
      </main>
    </div>
  </div>
  <div v-if="userHasPremission" class="footerLogo p-d-flex p-jc-center p-pb-6">
    <img src="@/assets/logo.png" width="200px"/>
  </div>
</div>
</template>

<script>
import navmenu from './navmenu'
import Message from 'primevue/message';

export default {
name: 'standardLayout',
components: {
  navmenu,
  Message
},

computed: {
  forceRerender(){
    return this.$store.getters['companies/rerender']
  },
  
  userHasPremission(){
    return this.$store.getters["user/level"]
  },
  
  project(){
    const project = this.$store.getters['projects/inspect']
    if(project == null)
      return false 
    else if(typeof project === 'object' && !Array.isArray(project) && !project.active){
      return project 
    }
    
    return false
  }
}
}
</script>

<style lang="sass">
.container 
  background-color: white
  
.footerLogo 
  margin-top: 200px 
  
</style>